var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-ins-progress-bar'),_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"page-fade","mode":"out-in"}},[_c('RouterView',{key:_vm.$route.path})],1)],1),_c('div',{attrs:{"id":"swal-output"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }